import { SuggestionDTO, ConversationDTO, RunDTO, ContainerDTO } from '../services/AssistantDTOs';
import { AutocompleteSuggestions, IAutocompleteSuggestions } from './AutocompleteSuggestions';
import { Conversation, IConversation } from './Conversation';
import { ConversationRun, IConversationRun } from './ConversationRun';
import { IConversationRunContainer } from './containers/ConversationRunContainer';
import { Suggestion } from './Suggestion';
import { IContainerFactory } from './containers/ContainerFactory';

export interface IPlacerAssistantFactory {
    createAutocompleteSuggestions(
        query: string,
        suggestions: SuggestionDTO[],
        session: string,
    ): IAutocompleteSuggestions;
    createConversation(conversation: ConversationDTO, runsDTO: RunDTO[]): IConversation;
    createNewConversation(conversationId: string): IConversation;
    createConversationRun(run: RunDTO): IConversationRun;
    createConversationRunContainer(container: ContainerDTO, id: string | number): IConversationRunContainer;
}

export class PlacerAssistantFactory implements IPlacerAssistantFactory {
    constructor(private containerFactory: IContainerFactory) {}
    createNewConversation(conversationId: string): IConversation {
        return this.createConversation(
            {
                id: conversationId,
                title: undefined,
                timestamp: undefined,
            },
            [],
        );
    }

    createConversationRun = (run: RunDTO): IConversationRun => {
        const containers = this.createConversationRunContainers(run.containers);
        const conversationRun = new ConversationRun(
            run.id,
            run.conversation_id,
            run.input,
            containers,
            run.status,
        );

        return conversationRun;
    };

    createConversation = (conversation: ConversationDTO, runsDTO: RunDTO[]): IConversation => {
        const runs = this.createConversationRuns(runsDTO);
        return new Conversation(conversation.id, conversation.title, runs, conversation.timestamp);
    };

    createSuggestion = (suggestion: SuggestionDTO) => {
        return new Suggestion(suggestion);
    };

    createAutocompleteSuggestions = (
        query: string,
        suggestions: SuggestionDTO[],
        session: string,
    ) => {
        return new AutocompleteSuggestions(query, suggestions.map(this.createSuggestion), session);
    };

    createConversationRuns = (runs: RunDTO[]): IConversationRun[] => {
        return runs.map(this.createConversationRun);
    };

    createConversationRunContainers = (containers: ContainerDTO[]): IConversationRunContainer[] => {
        return containers.map(this.createConversationRunContainer);
    };

    createConversationRunContainer = (
        container: ContainerDTO,
    ): IConversationRunContainer => {
        return this.containerFactory.createContainer(
            container.id,
            container.type,
            container.data,
        );
    };
}
